import { fill, messages, type Lang } from "../i18n/index";
import type { Store } from "./store";

/** The indicator only reports the initial texture burst; later lazy loads (8K maps) stay silent. */
const LOADING_WINDOW_MS = 10_000;

/** Indicator text, or null when it should be hidden. */
export function loadingText(
  completed: number,
  requested: number,
  elapsedMs: number,
  lang: Lang,
): string | null {
  if (elapsedMs > LOADING_WINDOW_MS || completed >= requested) return null;
  return fill(messages(lang).loading, { done: completed, total: requested });
}

export function mountLoading(
  container: HTMLElement,
  store: Store,
): {
  update(completed: number, requested: number, elapsedMs: number): void;
} {
  const el = document.createElement("div");
  el.className = "loading";
  el.hidden = true;
  container.append(el);
  let lastCompleted = -1,
    lastRequested = -1,
    lastLang = "",
    done = false;
  return {
    update(completed, requested, elapsedMs) {
      if (done) return;
      const expired = elapsedMs > LOADING_WINDOW_MS;
      const { lang } = store.state;
      if (
        !expired &&
        completed === lastCompleted &&
        requested === lastRequested &&
        lang === lastLang
      )
        return;
      lastCompleted = completed;
      lastRequested = requested;
      lastLang = lang;
      const text = loadingText(completed, requested, elapsedMs, lang);
      el.hidden = text === null;
      if (text !== null) el.textContent = text;
      if (expired) done = true;
    },
  };
}
